"use client";
import {
  useComboboxStore
} from "../__chunks/FEOFMWBY.js";
import {
  ComboboxContextProvider
} from "../__chunks/VEVQD5MH.js";
import "../__chunks/3XAVFTCA.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/O2PQ2652.js";
import "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/combobox/combobox-provider.tsx
import { jsx } from "react/jsx-runtime";
function ComboboxProvider(props = {}) {
  const store = useComboboxStore(props);
  return /* @__PURE__ */ jsx(ComboboxContextProvider, { value: store, children: props.children });
}
export {
  ComboboxProvider
};
